/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { MSTGQLRef, QueryBuilder, withTypedRefs } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { DriverDtoModel, DriverDtoModelType } from "./DriverDtoModel"
import { DriverDtoModelSelector } from "./DriverDtoModel.base"
import { RouteConstraintDtoModel, RouteConstraintDtoModelType } from "./RouteConstraintDtoModel"
import { RouteConstraintDtoModelSelector } from "./RouteConstraintDtoModel.base"
import { RouteLastLocationDtoModel, RouteLastLocationDtoModelType } from "./RouteLastLocationDtoModel"
import { RouteLastLocationDtoModelSelector } from "./RouteLastLocationDtoModel.base"
import { RouteSolutionDtoModel, RouteSolutionDtoModelType } from "./RouteSolutionDtoModel"
import { RouteSolutionDtoModelSelector } from "./RouteSolutionDtoModel.base"
import { RouteTagDtoModel, RouteTagDtoModelType } from "./RouteTagDtoModel"
import { RouteTagDtoModelSelector } from "./RouteTagDtoModel.base"
import { RouteTimelineEventDtoModel, RouteTimelineEventDtoModelType } from "./RouteTimelineEventDtoModel"
import { RouteTimelineEventDtoModelSelector } from "./RouteTimelineEventDtoModel.base"
import { RootStoreType } from "./index"


/* The TypeScript type that explicits the refs to other models in order to prevent a circular refs issue */
type Refs = {
  constraints: RouteConstraintDtoModelType;
  activeRouteSolution: RouteSolutionDtoModelType;
  publishedRouteSolution: RouteSolutionDtoModelType;
  driver: DriverDtoModelType;
}

/**
 * RouteDtoBase
 * auto generated base class for the model RouteDtoModel.
 */
export const RouteDtoModelBase = withTypedRefs<Refs>()(ModelBase
  .named('RouteDto')
  .props({
    __typename: types.optional(types.literal("RouteDto"), "RouteDto"),
    id: types.identifier,
    uuid: types.union(types.undefined, types.string),
    projectId: types.union(types.undefined, types.integer),
    name: types.union(types.undefined, types.null, types.string),
    transportationMode: types.union(types.undefined, types.null, types.string),
    solutionId: types.union(types.undefined, types.null, types.number),
    constraints: types.union(types.undefined, MSTGQLRef(types.late((): any => RouteConstraintDtoModel))),
    createdOn: types.union(types.undefined, types.string),
    startDate: types.union(types.undefined, types.string),
    activeRouteSolution: types.union(types.undefined, types.null, MSTGQLRef(types.late((): any => RouteSolutionDtoModel))),
    publishedRouteSolution: types.union(types.undefined, types.null, MSTGQLRef(types.late((): any => RouteSolutionDtoModel))),
    isLocked: types.union(types.undefined, types.boolean),
    driverId: types.union(types.undefined, types.null, types.integer),
    driver: types.union(types.undefined, types.null, MSTGQLRef(types.late((): any => DriverDtoModel))),
    action: types.union(types.undefined, types.null, types.string),
    completedStopsCount: types.union(types.undefined, types.null, types.integer),
    totalSkippedVisits: types.union(types.undefined, types.null, types.integer),
    totalCompletedVisits: types.union(types.undefined, types.null, types.integer),
    lastLocation: types.union(types.undefined, types.null, types.late((): any => RouteLastLocationDtoModel)),
    nextTimelineEvent: types.union(types.undefined, types.null, types.late((): any => RouteTimelineEventDtoModel)),
    routePerformanceEvent: types.union(types.undefined, types.null, types.late((): any => RouteTimelineEventDtoModel)),
    isDispatched: types.union(types.undefined, types.boolean),
    isScheduling: types.union(types.undefined, types.null, types.boolean),
    isUnscheduling: types.union(types.undefined, types.null, types.boolean),
    isDeleting: types.union(types.undefined, types.null, types.boolean),
    isReversing: types.union(types.undefined, types.null, types.boolean),
    deleted: types.union(types.undefined, types.null, types.boolean),
    lastSeen: types.union(types.undefined, types.null, types.string),
    driverViewStatus: types.union(types.undefined, types.null, types.string),
    hexColor: types.union(types.undefined, types.string),
    isStarted: types.union(types.undefined, types.null, types.boolean),
    tags: types.union(types.undefined, types.null, types.array(types.late((): any => RouteTagDtoModel))),
    isFinished: types.union(types.undefined, types.boolean),
    routeSolutionId: types.union(types.undefined, types.number),
    unpublishedChanges: types.union(types.undefined, types.boolean),
    stopsCount: types.union(types.undefined, types.number),
    distance: types.union(types.undefined, types.number),
    load: types.union(types.undefined, types.number),
    startTime: types.union(types.undefined, types.string),
    endTime: types.union(types.undefined, types.string),
    deliveredOrdersCount: types.union(types.undefined, types.number),
    missedOrdersCount: types.union(types.undefined, types.number),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  })))

export class RouteDtoModelSelector extends QueryBuilder {
  get id() { return this.__attr(`id`) }
  get uuid() { return this.__attr(`uuid`) }
  get projectId() { return this.__attr(`projectId`) }
  get name() { return this.__attr(`name`) }
  get transportationMode() { return this.__attr(`transportationMode`) }
  get solutionId() { return this.__attr(`solutionId`) }
  get createdOn() { return this.__attr(`createdOn`) }
  get startDate() { return this.__attr(`startDate`) }
  get isLocked() { return this.__attr(`isLocked`) }
  get driverId() { return this.__attr(`driverId`) }
  get action() { return this.__attr(`action`) }
  get completedStopsCount() { return this.__attr(`completedStopsCount`) }
  get totalSkippedVisits() { return this.__attr(`totalSkippedVisits`) }
  get totalCompletedVisits() { return this.__attr(`totalCompletedVisits`) }
  get isDispatched() { return this.__attr(`isDispatched`) }
  get isScheduling() { return this.__attr(`isScheduling`) }
  get isUnscheduling() { return this.__attr(`isUnscheduling`) }
  get isDeleting() { return this.__attr(`isDeleting`) }
  get isReversing() { return this.__attr(`isReversing`) }
  get deleted() { return this.__attr(`deleted`) }
  get lastSeen() { return this.__attr(`lastSeen`) }
  get driverViewStatus() { return this.__attr(`driverViewStatus`) }
  get hexColor() { return this.__attr(`hexColor`) }
  get isStarted() { return this.__attr(`isStarted`) }
  get isFinished() { return this.__attr(`isFinished`) }
  get routeSolutionId() { return this.__attr(`routeSolutionId`) }
  get unpublishedChanges() { return this.__attr(`unpublishedChanges`) }
  get stopsCount() { return this.__attr(`stopsCount`) }
  get distance() { return this.__attr(`distance`) }
  get load() { return this.__attr(`load`) }
  get startTime() { return this.__attr(`startTime`) }
  get endTime() { return this.__attr(`endTime`) }
  get deliveredOrdersCount() { return this.__attr(`deliveredOrdersCount`) }
  get missedOrdersCount() { return this.__attr(`missedOrdersCount`) }
  constraints(builder: string | RouteConstraintDtoModelSelector | ((selector: RouteConstraintDtoModelSelector) => RouteConstraintDtoModelSelector) | undefined) { return this.__child(`constraints`, RouteConstraintDtoModelSelector, builder) }
  activeRouteSolution(builder: string | RouteSolutionDtoModelSelector | ((selector: RouteSolutionDtoModelSelector) => RouteSolutionDtoModelSelector) | undefined) { return this.__child(`activeRouteSolution`, RouteSolutionDtoModelSelector, builder) }
  publishedRouteSolution(builder: string | RouteSolutionDtoModelSelector | ((selector: RouteSolutionDtoModelSelector) => RouteSolutionDtoModelSelector) | undefined) { return this.__child(`publishedRouteSolution`, RouteSolutionDtoModelSelector, builder) }
  driver(builder: string | DriverDtoModelSelector | ((selector: DriverDtoModelSelector) => DriverDtoModelSelector) | undefined) { return this.__child(`driver`, DriverDtoModelSelector, builder) }
  lastLocation(builder: string | RouteLastLocationDtoModelSelector | ((selector: RouteLastLocationDtoModelSelector) => RouteLastLocationDtoModelSelector) | undefined) { return this.__child(`lastLocation`, RouteLastLocationDtoModelSelector, builder) }
  nextTimelineEvent(builder: string | RouteTimelineEventDtoModelSelector | ((selector: RouteTimelineEventDtoModelSelector) => RouteTimelineEventDtoModelSelector) | undefined) { return this.__child(`nextTimelineEvent`, RouteTimelineEventDtoModelSelector, builder) }
  routePerformanceEvent(builder: string | RouteTimelineEventDtoModelSelector | ((selector: RouteTimelineEventDtoModelSelector) => RouteTimelineEventDtoModelSelector) | undefined) { return this.__child(`routePerformanceEvent`, RouteTimelineEventDtoModelSelector, builder) }
  tags(builder: string | RouteTagDtoModelSelector | ((selector: RouteTagDtoModelSelector) => RouteTagDtoModelSelector) | undefined) { return this.__child(`tags`, RouteTagDtoModelSelector, builder) }
}
export function selectFromRouteDto() {
  return new RouteDtoModelSelector()
}

export const routeDtoModelPrimitives = selectFromRouteDto().uuid.projectId.name.transportationMode.solutionId.createdOn.startDate.isLocked.driverId.action.completedStopsCount.totalSkippedVisits.totalCompletedVisits.isDispatched.isScheduling.isUnscheduling.isDeleting.isReversing.deleted.lastSeen.driverViewStatus.hexColor.isStarted.isFinished.routeSolutionId.unpublishedChanges.stopsCount.distance.load.startTime.endTime.deliveredOrdersCount.missedOrdersCount
